import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { EventEmitterProvider } from './contexts/EventEmmiter';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <EventEmitterProvider>
    <App />
  </EventEmitterProvider>
  // </React.StrictMode>
);

reportWebVitals();
